module.exports = "<p>\n  guard works!\n</p>\n"